export abstract class AbstractText {

}
